import { ComponentPropsWithoutRef, ReactNode } from 'react';

export interface FusszeileLink {
  label: string;
  href: string;
  /** Opens in a new tab and adds a notice for screen readers. */
  external?: boolean;
}

export interface FusszeileProps extends ComponentPropsWithoutRef<'footer'> {
  links?: FusszeileLink[];
  /** Right-hand side, usually the operator. */
  note?: ReactNode;
}

/**
 * Footer with the mandatory legal links (legal notice, privacy policy, accessibility
 * statement).
 *
 * KERN ships no footer component, so the design follows the KERN tokens and the standard's
 * typography (see styles.css). Labels are German, the portal's UI language.
 */
export const Fusszeile = ({
  links = [],
  note,
  className,
  ...props
}: FusszeileProps) => (
  <footer
    {...props}
    className={['vf-fusszeile', className].filter(Boolean).join(' ')}
  >
    <div className="vf-fusszeile__inner">
      <nav aria-label="Rechtliche Hinweise">
        <ul className="vf-fusszeile__links">
          {links.map(link => (
            <li key={link.href}>
              <a
                className="kern-link kern-link--small"
                href={link.href}
                {...(link.external
                  ? { target: '_blank', rel: 'noopener noreferrer' }
                  : {})}
              >
                {link.label}
                {link.external && (
                  <span className="kern-sr-only">
                    {' '}
                    (öffnet in neuem Fenster)
                  </span>
                )}
              </a>
            </li>
          ))}
        </ul>
      </nav>
      {note && (
        <p className="kern-body kern-body--small kern-body--muted">{note}</p>
      )}
    </div>
  </footer>
);
